
import RightbarContent from './rightbar-content.vue'

export default {
  components: {RightbarContent},
  props: {
    view: {type: String, default: undefined, validator: v => ['signal', 'edit-company', 'edit-person', 'edit-topic', 'track-company', 'track-person', 'track-companies', 'track-topic'].includes(v)},
    data: {type: Object, default: undefined}
  },
  emits: ['close'],
  methods: {
    close(){
      this.$emit('close')
    }
  }
}
